import type { ProductScoreGaugeProps } from '@which/seatbelt'

export const addHandlerToTestScoreTooltip = (
  productScoreGauge: ProductScoreGaugeProps,
  openHandler: ProductScoreGaugeProps['tooltip']['openHandler'],
  closeHandler?: ProductScoreGaugeProps['tooltip']['closeHandler']
) => {
  if (productScoreGauge?.tooltip) {
    const transformedGauge = {
      ...productScoreGauge,
      tooltip: {
        ...productScoreGauge.tooltip,
        openHandler,
        closeHandler,
      },
    }

    return transformedGauge
  }

  return productScoreGauge
}
